import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/ar-aging")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "9e548abc-3df8-5920-b799-b73f65a9b00c" }, replace: true });
  },
  component: () => null,
});
